import { useState } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ShoppingBag } from 'lucide-react';
import { useCart } from '../../Context/CartContext';

const ProductCard = ({ product }) => {
  const [isHovered, setIsHovered] = useState(false);
  const { addToCart } = useCart();
  
  const handleAddToCart = (e) => {
    e.preventDefault();
    e.stopPropagation();
    addToCart(product, 1);
  };

  return (
    <motion.div 
      className="card h-full py-3"
      whileHover={{ y: -5 }}
      transition={{ duration: 0.3 }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <Link to={`/products/detail/${product.id}`} className="block h-full">
        <div className="relative overflow-hidden aspect-square py-1">
          <img 
            src={`${process.env.REACT_APP_BASE_URL}${product.photo_url}`}
            alt={product.name}
            className="w-full h-full object-contain transition-transform duration-500 ease-in-out"
            style={{ transform: isHovered ? 'scale(1.05)' : 'scale(1)' }}
          />
          
          {product.in_stock && !product.show_sizes && !product.show_colors && (
  <motion.div 
    initial={{ opacity: 0 }}
    animate={{ opacity: isHovered ? 1 : 0 }}
    transition={{ duration: 0.3 }}
    className="absolute bottom-0 left-0 right-0 bg-white/90 p-3 flex justify-between"
  >
    <button 
      onClick={handleAddToCart}
      className="text-gray-dark hover:text-primary transition-colors"
      aria-label="Add to cart"
    >
      <ShoppingBag size={20} />
    </button>
  </motion.div>
)}
          {/* Out of stock badge */}
          {!product.in_stock && (
            <div className="absolute top-2 right-2 bg-gray-dark text-white text-xs font-medium py-1 px-2 rounded">
              Tükendi
            </div>
          )}
        </div>

        <div className="p-4">
          <h3 className="font-medium text-gray-dark">{product.name}</h3>
          <p className="text-primary font-semibold mt-1">{parseFloat(product.price).toFixed(2)} ₺</p>
        </div>
      </Link>
    </motion.div>
  );
};

export default ProductCard;
